import { newsConstants } from "@constants";

const initalState = {
  typeOptions: {
    loading: false,
    data: [],
    fail: null
  }
};

export const newsEdit = (state = initalState, action) => {
  switch (action.type) {
    case newsConstants.GET_TYPE_OPTIONS_REQUEST:
      return {
        ...state,
        typeOptions: {
          loading: true,
          data: []
        }
      };
    case newsConstants.GET_TYPE_OPTIONS_SUCCESS:
      return {
        ...state,
        typeOptions: {
          loading: false,
          data: action.typeOptions
        }
      };
    case newsConstants.GET_TYPE_OPTIONS_FAILURE:
      return {
        ...state,
        typeOptions: {
          loading: false,
          data: [],
          fail: action.error
        }
      };
    case newsConstants.RESET_TYPE_OPTIONS_SUCCESS:
      return {
        ...state,
        typeOptions: initalState.typeOptions
      };
    default:
      return state;
  }
};
